module.exports = __webpack_public_path__ + "img/ic-comment.6947fd8a.svg";